module.exports = __webpack_public_path__ + "static/9-code-safety-through-code-audits-d1a1eed3f9276a2ec64ff17b6950b682.jpg";